import { Trans } from '@lingui/macro'
import { Logout } from '@mui/icons-material'
import { Button, Tooltip, Typography } from '@mui/material'
import { logoutUser } from 'app/redux/actions/UserActions'
import { ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const LogoutButton: React.FC<{ isSmallScreen?: boolean }> = ({ isSmallScreen = false }) => {
  const dispatch = useDispatch()
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)

  return (
    <div className='topbar-button-box'>
      <Button
        sx={{ padding: 0, fontWeight: 400 }}
        variant='text'
        onClick={e => {
          dispatch(logoutUser(), user)
        }}
      >
        {isSmallScreen
          ? (
            <Tooltip title={<Trans>LOGOUT</Trans>}>
              <Logout sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
            </Tooltip>
            )
          : (
            <>
              <Logout sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
              <Typography sx={{ color: 'black' }}>
      <Trans>
                LOGOUT
              </Trans>
    </Typography>
            </>
            )}
      </Button>
    </div>
  )
}
